import React, { FC } from 'react'
import { Segment, Grid } from 'semantic-ui-react'
// @ts-ignore
import { Container, FakeInput, GridContainer, SegmentGroup } from 'shared/StyledComponents'
import { LKDate } from 'loankeeper-common/helpers/Date'
import { translate } from 'loankeeper-common/helpers'
import { LKHeader } from 'loankeeper-common/components'

import { translbl } from '../translator'
import { AccountDetailsBaseData } from '../AccountDetails.types'

const Base: FC<{
  data: AccountDetailsBaseData
}> = ({ data }) => (
  <Container>
    <SegmentGroup>
      <Segment.Group>
        <Segment className="devided">
          <GridContainer>
            <Grid>
              <Grid.Row>
                <Grid.Column width={3} textAlign="right" verticalAlign="middle">
                  {translate(`${translbl}_fullname_t`)}
                </Grid.Column>

                <Grid.Column width={13}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{`${data.ClientFullName} - ${data.ClientSerial}`}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>
        </Segment>

        <Segment className="devided">
          <GridContainer>
            <Grid>
              <Grid.Row>
                <Grid.Column width={3} textAlign="right" verticalAlign="middle">
                  {translate(`${translbl}_acc_no_title`)}
                </Grid.Column>

                <Grid.Column width={4}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.AccNo}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column width={9}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.TitleUNI}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column width={7} />

                <Grid.Column width={9}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.Title_ALTUNI}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>
        </Segment>

        <Segment className="devided">
          <GridContainer>
            <Grid>
              <Grid.Row>
                <Grid.Column width={3} textAlign="right" verticalAlign="middle">
                  {translate(`${translbl}_balcode`)}
                </Grid.Column>

                <Grid.Column width={4}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.BalCodeID}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column width={9}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.BalCode}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>
        </Segment>

        <Segment>
          <GridContainer>
            <Grid>
              <Grid.Row>
                <Grid.Column width={3} textAlign="right" verticalAlign="middle">
                  {translate(`${translbl}_actpas`)}
                </Grid.Column>

                <Grid.Column width={4}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.ActPas}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column width={3} textAlign="right" verticalAlign="middle">
                  {translate(`${translbl}_account_type`)}
                </Grid.Column>

                <Grid.Column width={6}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.Type}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column width={3} textAlign="right" verticalAlign="middle">
                  {translate(`${translbl}_reapprise`)}
                </Grid.Column>

                <Grid.Column width={4}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.Reapprise}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column width={3} textAlign="right" verticalAlign="middle">
                  {translate(`${translbl}_node`)}
                </Grid.Column>

                <Grid.Column width={6}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.Node}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column width={3} textAlign="right" verticalAlign="middle">
                  {translate(`${translbl}_autoclose_acc`)}
                </Grid.Column>

                <Grid.Column width={13}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.AutoCloseAcc}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>
        </Segment>

        <Segment>
          <GridContainer>
            <Grid>
              <Grid.Row>
                <Grid.Column width={3} textAlign="right" verticalAlign="middle">
                  {translate(`${translbl}_opendate`)}
                </Grid.Column>

                <Grid.Column width={4}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{LKDate.from(data.OpenDate).toString()}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column width={3} textAlign="right" verticalAlign="middle">
                  {translate(`${translbl}_closedate`)}
                </Grid.Column>

                <Grid.Column width={6}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{LKDate.from(data.CloseDate).toString()}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>
        </Segment>

        <Segment>
          <GridContainer>
            <Grid>
              <Grid.Row>
                <Grid.Column width={3} textAlign="right" verticalAlign="middle">
                  {translate(`${translbl}_acc_balance`)}
                </Grid.Column>

                <Grid.Column width={4}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.Balance}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column width={3} textAlign="right" verticalAlign="middle">
                  {translate(`${translbl}_iso`)}
                </Grid.Column>

                <Grid.Column width={6}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.CCY}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>
        </Segment>

        <Segment>
          <GridContainer>
            <Grid>
              <Grid.Row>
                <Grid.Column width={3} textAlign="right" verticalAlign="middle">
                  {translate(`${translbl}_seclevel`)}
                </Grid.Column>

                <Grid.Column width={4}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.SecLevel}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>

                <Grid.Column width={3} />

                <Grid.Column width={6}>
                  <FakeInput>
                    <Segment>
                      <LKHeader size="small">{data.ID}</LKHeader>
                    </Segment>
                  </FakeInput>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>
        </Segment>
      </Segment.Group>
    </SegmentGroup>
  </Container>
)

export default Base
